// Fields, defaults, and library info for this section. The editor builds its form from `fields`.
const definition = {
  order: 80,
  type: "rich_text",
  name: "Rich Text / Trust Badges",
  category: "Content",
  description: "Centered text block with trust credentials (warranty, returns, COD, shipping)",
  defaultSettings: {
    heading: "The Gootocart Standard",
    content: "⚡ Express Nationwide Dispatch • 🛡️ 100% Genuine Merchandise • 📦 Cash on Delivery • 📞 Dedicated Customer Support",
    alignment: "center",
  },
  fields: [
    { key: "heading", label: "Heading", type: "text" },
    { key: "content", label: "Content / Trust Points", type: "textarea" },
    {
      key: "layout",
      label: "Layout",
      type: "select",
      options: [
        { value: "badges", label: "Trust badges" },
        { value: "stories", label: "Three stories" },
      ],
    },
    { key: "story1Title", label: "First story title", type: "text", showWhen: { key: "layout", value: "stories" } },
    { key: "story1Text", label: "First story", type: "textarea", showWhen: { key: "layout", value: "stories" } },
    { key: "story2Title", label: "Second story title", type: "text", showWhen: { key: "layout", value: "stories" } },
    { key: "story2Text", label: "Second story", type: "textarea", showWhen: { key: "layout", value: "stories" } },
    { key: "story3Title", label: "Third story title", type: "text", showWhen: { key: "layout", value: "stories" } },
    { key: "story3Text", label: "Third story", type: "textarea", showWhen: { key: "layout", value: "stories" } },
    {
      key: "alignment",
      label: "Text Alignment",
      type: "select",
      options: [
        { value: "center", label: "Center" },
        { value: "left", label: "Left" },
      ],
    },
  ],
};

export default definition;
